import { combineReducers } from 'redux'
import { InvestmentsDetailsUIStateReducer } from '../InvestmentsDetailsUIState'
import { investmentsTableReducer } from './InvestmentsTable'

export const investmentsModuleFeatureReducer = combineReducers({
  investmentsTable: investmentsTableReducer,
  investmentsDetails: InvestmentsDetailsUIStateReducer
})
